import React, { useState } from 'react';
import { Input } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import I18n from 'i18n-js';
import { arrayOf, bool, func } from 'prop-types';
import {
  containsAllTerms, matchesSearch, searchSnippet, searchTerms,
} from 'components/tickets-dashboard/helpers/ticketSearch';
import HighlightedText from 'components/tickets-dashboard/nested/HighlightedText';
import StatusLabel from './StatusLabel';
import { selectedNodePropTypes } from '../propTypes';

const MAX_OPTIONS = 50;

const LinkTicketPalette = ({
  candidates = [], disabled = false, onLink = () => {}, onClose = () => {},
}) => {
  const [query, setQuery] = useState('');

  const terms = searchTerms(query);
  const options = candidates
    .filter((ticket) => matchesSearch(ticket, query))
    .slice(0, MAX_OPTIONS);

  const handleBlur = (event) => {
    if (!event.currentTarget.contains(event.relatedTarget)) onClose();
  };

  return (
    <div className="tickets-index-page__link-palette" onBlur={handleBlur}>
      <Input
        autoFocus
        variant="borderless"
        size="large"
        className="tickets-index-page__link-palette-input"
        aria-label={I18n.t('tickets.form.link_ticket_hint')}
        placeholder={I18n.t('tickets.form.link_ticket_hint')}
        prefix={<SearchOutlined />}
        value={query}
        onChange={(event) => setQuery(event.target.value)}
      />

      <div className="tickets-index-page__link-palette-options">
        {options.length === 0 && (
          <div className="tickets-index-page__link-palette-empty">
            {I18n.t('shared.no_results_found')}
          </div>
        )}
        {options.map((ticket) => {
          const snippet = containsAllTerms(ticket.title, terms)
            ? null
            : searchSnippet(ticket.description, terms);

          return (
            <button
              key={ticket.id}
              type="button"
              className="tickets-index-page__link-palette-option"
              disabled={disabled}
              onMouseDown={(event) => event.preventDefault()}
              onClick={() => onLink(ticket.id)}
            >
              <span className="tickets-index-page__linked-ticket-id">{`#${ticket.id}`}</span>
              <span className="tickets-index-page__link-palette-option-text">
                <span className="tickets-index-page__link-palette-option-title">
                  <HighlightedText text={ticket.title} terms={terms} />
                </span>
                {snippet && (
                  <span className="tickets-index-page__link-palette-option-snippet">
                    <HighlightedText text={snippet} terms={terms} />
                  </span>
                )}
              </span>
              <StatusLabel status={ticket.status} />
            </button>
          );
        })}
      </div>
    </div>
  );
};

LinkTicketPalette.propTypes = {
  candidates: arrayOf(selectedNodePropTypes),
  disabled: bool,
  onLink: func,
  onClose: func,
};

export default LinkTicketPalette;
